<template>
<div class="k-page-content" v-loading="loading">
	<div class="messageContent">
		<div class="title">{{info.title}}</div>
		<div class="tips">
			<span style="margin-right: 30px;">发布时间：{{info.send_time}}</span><span>来自于：{{info.send_name}}</span>
		</div>
		<div class="box">{{info.content}}</div>
	</div>
</div>
</template>
<script>
export default {
  data() {
      return {
		  loading:false,
		  queryParams:{},
		  info:{}
      }
	},
	computed: {
		
	},
	mounted: function () {
		this.loading = true
		this.queryParams = this.$route.query;
		this.getDetail()
	},
	methods: {
		getDetail(){
			this.$api.get('/admin/news/message/info',{id:this.queryParams.id}).then(res => {
			  if (res.code === 0) {
				 this.$api.get('/admin/news/message/getcontent',{id:this.queryParams.id}).then(res => {
				   if (res.code === 0) {
				 	  this.info = res.data
				   } else {
				 	 this.$message.error(res.msg);
				   }
				   this.loading = false
				 })
			  } else {
				 this.$message.error(res.msg);
			  }
			})
		}
	}
}
</script>
<style lang="scss" scoped>
	.messageContent{
		padding: 20px;
		background-color: #fff;
		box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.05);
		border-radius: 2px;
		min-height: calc(100vh - 110px);
		box-sizing: border-box;
		width: calc(100% - 40px);
		margin: 20px;
		.title{
			color: #333;
			font-size: 28px;
			line-height: 80px;
			text-align: center;
		}
		.tips{
			font-size: 14px;
			color: #a1a1a1;
			text-align: center;
			border-bottom: 1px solid #d7dadf;
			padding-bottom: 15px;
		}
		.box{
			padding-top: 20px;
			font-size: 16px;
		}
	}
</style>